import {Table, TableBody, TableCell, TableHead, TableRow} from '@mui/material'
import {FieldArrayWithId, UseFieldArrayRemove} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

import {HeatZonesTableRow} from './HeatZonesTableRow'

import {useGetHeatZoneNames} from '@kilnfeature/api/queries/useGetHeatZoneNames'
import {HeatZone} from '@kilnfeature/types/heatZones.types'

type HeatZonesTableProps = {
  fields: FieldArrayWithId<{heatZones: HeatZone[]}, 'heatZones'>[]
  remove: UseFieldArrayRemove
  kilnLength: number
}
export const HeatZonesTable = ({fields, remove, kilnLength}: HeatZonesTableProps) => {
  const {t} = useTranslation()
  const {data: heatZonesSettings = [], isLoading} = useGetHeatZoneNames()

  // Transform API data to options format with i18n translations
  // The translation key format is: heatZones.zones.<enumValue>
  const heatZoneOptions = heatZonesSettings.map((zone) => ({
    label: t(`heatZones.zones.${zone.enumValue}`, zone.enumValue),
    value: zone.enumValue
  }))

  if (isLoading) {
    return null
  }

  return (
    <Table data-test-id="heat_zones_table">
      <TableHead data-test-id="heat_zones_table_head">
        <TableRow>
          <TableCell align={'center'}>#</TableCell>
          <TableCell>{t('common.name')}</TableCell>
          <TableCell align={'center'}>{t('common.start')}</TableCell>
          <TableCell align={'center'}>{t('common.end')}</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {fields.map((heatZone, index) => (
          <HeatZonesTableRow
            key={`heatZones.${index}.row`}
            index={index}
            remove={remove}
            numberOfRows={fields.length - 1}
            kilnLength={kilnLength}
            heatZoneOptions={heatZoneOptions}
          />
        ))}
      </TableBody>
    </Table>
  )
}
